// Item pequeno dentro de uma caixa (checklist, lista, passos, subtarefas).
// Texto 28 (B1, REGRAS 2.3): itens pequenos NÃO deslizam para o lado. Excluir e Duplicar ficam no ⋮ do item
// (vazio sai sem perguntar; com texto pergunta; sempre com "Desfazer"). O deslizar para o lado fica só nas caixas e
// cartões grandes; o toque que começa no item não faz o cartão de fora deslizar (lib/gestos).
// Segurar ~1 s e arrastar continua movendo o item (Ordenavel).
import { useState, type ReactNode } from 'react';
import { Alert, Pressable, Text, View } from 'react-native';
import { ActionSheet, type Action } from './ui';
import { C } from './theme';
import { t } from '../lib/i18n';
import { oferecerDesfazer } from '../lib/desfazer';
import { marcarToqueInterno } from '../lib/gestos';

/** Põe x de volta na posição em que estava (para o "Desfazer"). */
export function inserirEm<T>(lista: T[], pos: number, x: T): T[] {
  const p = Math.max(0, Math.min(pos, lista.length));
  return [...lista.slice(0, p), x, ...lista.slice(p)];
}

/** Exclui um item pequeno (REGRAS 4.1): vazio sai direto; com conteúdo pergunta. tirar() devolve a função que o põe de volta. */
export function excluirPequeno(temConteudo: boolean, tirar: () => (() => void) | void, pergunta = t('Excluir este item?'), detalhe = '') {
  const ir = () => { const volta = tirar(); if (volta) oferecerDesfazer('excluir', volta); };
  if (!temConteudo) { ir(); return; }
  Alert.alert(pergunta, detalhe, [{ text: t('Cancelar'), style: 'cancel' }, { text: t('Excluir'), style: 'destructive', onPress: ir }]);
}

/** Marca o toque como "de dentro" sem deslizar nada (REGRAS 3.5: deslizar dentro de um bloco não faz nada). */
export function SemDeslizar({ children, style }: { children: ReactNode; style?: any }) {
  return <View onStartShouldSetResponderCapture={marcarToqueInterno} style={style}>{children}</View>;
}

export function ItemDeslizar({ onExcluir, onDuplicar, children, semMenu, extras }: {
  /** já com a regra 4.1 (use excluirPequeno) */
  onExcluir: () => void; onDuplicar?: () => void; children: ReactNode;
  /** o item já tem o próprio ⋮ (ex.: as caixas de Anotações, com "Mover para…") */
  semMenu?: boolean;
  /** opções a mais no ⋮, antes de Duplicar e Excluir */
  extras?: Action[];
  /** @deprecated texto 28: não desliza mais */ desligado?: boolean;
}) {
  const [menu, setMenu] = useState<Action[] | null>(null);
  const abrir = () => setMenu([...(extras ?? []), ...(onDuplicar ? [{ label: '⧉ ' + t('Duplicar'), onPress: onDuplicar }] : []),
    { label: t('Excluir'), destructive: true, onPress: onExcluir }]);
  if (semMenu) return <SemDeslizar>{children}</SemDeslizar>;
  return (
    <SemDeslizar style={{ flexDirection: 'row', alignItems: 'center' }}>
      <View style={{ flex: 1, minWidth: 0 }}>{children}</View>
      <Pressable onPress={abrir} hitSlop={8} accessibilityLabel={t('Opções do item')} style={{ paddingHorizontal: 4, paddingVertical: 4 }}>
        <Text style={{ color: C.mute, fontSize: 16, fontWeight: '800' }}>⋮</Text>
      </Pressable>
      <ActionSheet title={t('Item')} actions={menu} onClose={() => setMenu(null)} />
    </SemDeslizar>
  );
}
